module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_8004.e09adf76.png";